import { AssetConfig } from "../index";

export const ActivityAssetConfig: AssetConfig = {
    name: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
    rebateEligible: {type: "BOOLEAN",required: true,editable: true,label: "Eligible for tax rebate",rank: 2},
}